'use strict';
const insuranceCatalogueCollection = require('od-modules/collections/insurance_catalogue.collection').getInstance();
const trackingUtils = require('od-modules/utils/tracking.utils');
const accommodationPostBookingUrlService = require('od-modules/accommodation/accommodationPostBookingUrlService');

const TRIPDETAILS_URL = '#tripdetails/newtab';
const HSA_PB_POPUNDER = 'HSA_PB_POPUNDER';

Odigeo.defineWidget('waiting_pages', Odigeo.Widget.extend({
    viewClass: Odigeo.View.extend({
        events: {
            'click .cosearch_hotels': 'executeHotelsPBCoSearch',
        },

        selectors: {
            cities: '.waiting_cities',
            departureDate: '.waiting_departure_date',
            returnDate: '.waiting_return_date',
            multipleDate: '.waiting_multiple_date',
            passengers: '.waiting_passengers',
            destCity: '.waiting_loading_destination',
            itineraryBox: '.itinerary_box',
            pluralizeKey: '.pluralize_key',
        },
        executeHotelsPBCoSearch() {
            const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
            const status = bookingInfo.myTripStatus || '';
            const flow = 'flights';
            trackRedirection(status.toLowerCase(), flow);
            window.open(TRIPDETAILS_URL, '_blank');
            Odigeo.Session.set('isAccommodationPostBookingCoSearch', true);
            if (Odigeo.AB.isAccommodationDeepLinkPostBookingUrl && Odigeo.AB.isAccommodationDeepLinkPopunder) {
                accommodationPostBookingUrlService.get({
                    bookingId: bookingInfo.bookingBasicInfo.id,
                    email: bookingInfo.buyer.mail,
                    buyPath: HSA_PB_POPUNDER,
                }).then((url) => window.location.href = url)
                    .catch(() => Odigeo.Utils.launchAccommodationPBSearch(HSA_PB_POPUNDER));
            } else {
                Odigeo.Utils.launchAccommodationPBSearch(HSA_PB_POPUNDER);
            }
        },
        cleanElements(listToClean) {
            Odigeo._.each(listToClean, function(value) {
                this.$cachedSelectors[value].html('');
            }, this);
        },
        fillSearchWaitingPage(waitingDetails) {
            this.cleanElements(['destCity', 'returnDate', 'departureDate', 'multipleDate']);
            if (Odigeo._.includes(['oneWayTrip', 'roundTrip'], waitingDetails.tripType)) {
                this.setTripData(waitingDetails);
            } else {
                this.$cachedSelectors.cities.html(Odigeo.UIElements.translations.waitings.multipleCities);
                this.$cachedSelectors.multipleDate.html(Odigeo.UIElements.translations.waitings.multipleDates);
            }
            this.replaceTexts('passengers', waitingDetails.numAdults + waitingDetails.numChildren + waitingDetails.numInfants);
            this.$cachedSelectors.itineraryBox.addClass('active');
        },
        setTripData(waitingDetails) {
            this.$cachedSelectors.cities.html(`<span>${waitingDetails.depCity}</span> - <span>${waitingDetails.destCity}</span>`);
            this.fillDates(waitingDetails.departureDate, waitingDetails.returnDate);
            this.replaceTexts('destCity', waitingDetails.destCity);
            if (this.widget.options.isWaitingMessagesActive) {
                this.replaceTexts('pluralizeKey', waitingDetails.tripType === 'oneWayTrip' ? 1 : 0);
            }
        },
        parseDate(date) {
            return Odigeo.Utils.formatDate(Odigeo.Utils.parseDate(date), this.widget.options.format, true);
        },
        fillDates(departureDate, returnDate) {
            this.$cachedSelectors.departureDate.text(departureDate);
            this.$cachedSelectors.returnDate.text(returnDate);
        },
        replaceText($selector, text) {
            $selector.html(Odigeo.Utils.pluralizeAll($selector.data('key'), text));
        },
        replaceTexts(selector, value) {
            Odigeo._.each(this.$cachedSelectors[selector], function(element) {
                this.replaceText($(element), value);
            }, this);
        },
    }),
    init: function() {
        this.options = Odigeo.parseOptions(this.options);
    },
    initSearchWaiting(searchParameters) {
        if (Odigeo._.isObject(searchParameters) && Odigeo._.isArray(searchParameters.searchSegments)) {
            const depSegment = searchParameters.searchSegments[0];
            const retSegment = searchParameters.searchSegments[1];
            this.view.fillSearchWaitingPage({
                numAdults: parseInt(searchParameters.numAdults, 10) || 0,
                numChildren: parseInt(searchParameters.numChildren, 10) || 0,
                numInfants: parseInt(searchParameters.numInfants, 10) || 0,
                tripType: searchParameters.type,
                depCity: depSegment.departure.city,
                destCity: depSegment.destination.city,
                departureDate: this.view.parseDate(depSegment.dateStr),
                returnDate: Odigeo._.isObject(retSegment) && retSegment.dateStr ? ' - ' + this.view.parseDate(retSegment.dateStr) : '',
            });

            insuranceCatalogueCollection.getLoadedPromise().then((loaded) => {
                if (loaded && insuranceCatalogueCollection.isCancellationFreeCandidate()) {
                    const departureDate = depSegment.dateStr.replace(/-/g, '/');
                    const twoDaysInMiliseconds = 172800000;
                    const currentDate = new Date();
                    const isDateInRange = new Date(departureDate) - currentDate > twoDaysInMiliseconds;

                    this.view.$el.find('.flex_waiting').toggleClass('odf-hidden', !isDateInRange);
                    this.view.$el.find('.results_waiting').toggleClass('odf-hidden', isDateInRange);
                    this.view.$el.find('.standard_waiting').toggleClass('odf-hidden', isDateInRange);
                    Odigeo.Session.set('isFlexibilityDisruptionWaitingActive', isDateInRange);
                } else {
                    Odigeo.Session.set('isFlexibilityDisruptionWaitingActive', false);
                }
            });
        }
    },

    initFlexibilityDisruptionWaiting() {
        const isFlexWaiting = Odigeo.Utils.parseJson(Odigeo.Session.get('isFlexibilityDisruptionWaitingActive')) || false;
        this.view.$el.find('.flex_waiting').toggleClass('odf-hidden', !isFlexWaiting);
        this.view.$el.find('.standard_waiting').toggleClass('odf-hidden', isFlexWaiting);
    },
}));

function trackRedirection(status, flow) {
    trackingUtils.trackEventWithCategory(`${flow}_confirmation_page_${status}`, 'access_my_trip_details',
        'automatic_redirection_successful');
}
